const locale = {
	HELP_CENTER: 'Help Center',
	HELP_CENTER_TITLE: 'How can we help you today?',
	HELP_CENTER_DESCRIPTION: 'We are here to help you with any questions or concerns you may have. Please use the search bar to find the information you need.',
	HELP_CENTER_SEARCH: 'Search',
	HELP_CENTER_SEARCH_PLACEHOLDER: 'Search for a topic',
	HELP_CENTER_SEARCH_RESULTS: 'Search results',
	HELP_CENTER_SEARCH_NO_RESULTS: 'No results found',
	HELP_CENTER_SEARCH_NO_RESULTS_DESCRIPTION: 'Please try again with different keywords.',
	FAQs: 'FAQs',
	FAQs_DESCRIPTION: 'Frequently asked questions and answers',
	GO_TO_FAQS: 'Go to FAQs',
	GUIDES: 'User Manual',
	GUIDES_DESCRIPTION: 'Articles and resources to guide you',
	GO_TO_GUIDES: 'Go to User Manual',
	SUPPORT: 'Support',
	SUPPORT_DESCRIPTION: 'Contact us for more detailed support',
	GO_TO_SUPPORT: 'Go to Support',
	MOST_FREQUENTLY_ASKED_QUESTIONS: 'Most Frequently Asked Questions',
	MOST_FREQUENTLY_ASKED_QUESTIONS_DESCRIPTION: 'Here are the most frequently asked questions you may check before getting started',
	
	// Guide Categories
	GUIDES_AND_RESOURCES: 'Guides & Resources',
	GETTING_STARTED: 'Getting Started',
	GETTING_STARTED_DESCRIPTION: 'Essential guides to help you get started with our platform',
	ACCOUNT_MANAGEMENT: 'Account Management',
	ACCOUNT_MANAGEMENT_DESCRIPTION: 'Manage your account settings, profile, and preferences',
	CLEANING_MANAGEMENT: 'Управление на Почистване',
	CLEANING_MANAGEMENT_DESCRIPTION: 'Научете как работи почистването на стаите',
	CLEANING_OPERATIONS: 'Страница Почистване (Главен Камериер и Администратор)',
	CLEANING_OPERATIONS_DESCRIPTION: 'Научете как се извършва почистването на стаите',
	CLEANING_OPERATIONS_SUBTITLE: '',
	CLEANING_PAGE_CLEANER: 'Страница Почистване (Камериер)',
	CLEANING_PAGE_CLEANER_SUBTITLE: 'Научете как да извършите Почистване',
	CLEANER_SUBMIT_PROBLEM: 'Страница Почистване: Докладване на проблем',
	CLEANER_SUBMIT_PROBLEM_SUBTITLE: '',
	FEATURES_AND_TOOLS: 'Features & Tools',
	FEATURES_AND_TOOLS_DESCRIPTION: 'Learn about advanced features and tools available',
	TROUBLESHOOTING: 'Troubleshooting',
	TROUBLESHOOTING_DESCRIPTION: 'Common issues and their solutions',
	
	// Articles
	WELCOME_TO_OUR_PLATFORM: 'Welcome to Our Platform',
	WELCOME_TO_OUR_PLATFORM_SUBTITLE: 'Your complete guide to getting started with our platform',
    TEAM_MANAGEMENT: 'Team Management',
    TEAM_MANAGEMENT_SUBTITLE: 'Learn how to manage your team',
	PASSWORD_SECURITY_BEST_PRACTICES: 'Password Security Best Practices',
	PASSWORD_SECURITY_BEST_PRACTICES_SUBTITLE: 'Learn how to create and maintain secure passwords',
	ADVANCED_SEARCH_TECHNIQUES: 'Advanced Search Techniques',
	ADVANCED_SEARCH_TECHNIQUES_SUBTITLE: 'Master the search functionality to find exactly what you need',
	COMMON_LOGIN_ISSUES: 'Common Login Issues and Solutions',
	COMMON_LOGIN_ISSUES_SUBTITLE: 'Troubleshoot the most common login problems',
	OVERVIEW: 'Обобщен преглед на дневната дейност',
	OVERVIEW_SUBTITLE: 'Каква информация можете да намерите в дневния преглед?', 
	DAILY_ASSIGNMENTS_LIST: 'Списък със задачите на всеки камериер за деня',
	DAILY_ASSIGNMENTS_LIST_SUBTITLE: '',
	ROOMIE_AI_INTELLIGENT_ASSISTANT: 'Roomie AI Интелигентен Асистент',
	ROOMIE_AI_INTELLIGENT_ASSISTANT_SUBTITLE: 'Научете как да използвате Roomie AI Интелигентен Асистент',
	
	// Article Content
	WELCOME_CONTENT: `
		<h3>What You Will Learn</h3>
		<ul>
			<li>How to create floors</li>
			<li>How to create rooms</li>
			<li>How to create cleaning checklists</li>
			<li>How to create maintenance items</li>
		</ul>
		
        <h3>How to create a floor</h3>
        <img src="/assets/images/help-center/hotel-settings-floors-en.png" style="border: 1px solid #ccc" />
		
		<h4>Step 1: Fill in the fields</h4>
		<p>Fill in the "Floor Name" and "Floor Number" fields.</p>
		
		<h4>Step 2: Click the "Create Floor" button</h4>
		<p>The floor will be created and will appear in the list of floors.</p>
        <hr>
        <h3>How to create a room</h3>
        <img src="/assets/images/help-center/hotel-settings-rooms-en.png" style="border: 1px solid #ccc" />
		
		<h4>Step 1: Fill in the fields</h4>
		<p>Fill in the "Name", "Number of Beds", "Floor" and "Room Type" fields.</p>
		
		<h4>Step 2: Click the "Create Room" button</h4>
		<p>The room will be created and will appear in the list of rooms.</p>
        <hr>
        <h3>How to create a cleaning checklist</h3>
        <img src="/assets/images/help-center/hotel-settings-cleaning-checklist-en.png" style="border: 1px solid #ccc" />

        <h4>Step 1: Click the "Create Checklist" button</h4>
		<p>A window for creating a cleaning checklist will appear.</p>
        <img src="/assets/images/help-center/hotel-settings-checklist-creation-en.png" style="border: 1px solid #ccc" />
		
		<h4>Step 2: Fill in the required fields of the checklist</h4>
		<p>Fill in the "Checklist Name" field.</p>

        <h4>Step 3: Fill in the required fields of the task</h4>
		<p>Fill in the "Task Title", "Category (Bedroom, Bathroom or Both)" and check the box whether the task is required.</p>
		
        <h4>Step 4: Click the "Add Task" button</h4>
		<p>The task will be added to the cleaning checklist. You can add more tasks by repeating steps 3 and 4.</p>

		<h4>Step 5: Click the "Create Checklist" button</h4>
		<p>The checklist will be created with the added tasks and will appear in the other cleaning checklists.</p>

        <hr>
        <h3>How to create a maintenance item</h3>
        <img src="/assets/images/help-center/hotel-settings-maintenance-items-en.png" style="border: 1px solid #ccc" />

        <h4>Step 1: Click the "Create Maintenance Item" button</h4>
		<p>A window for creating a maintenance item will appear.</p>
        <img src="/assets/images/help-center/hotel-settings-maintenance-item-creation-en.png" style="border: 1px solid #ccc" />

        <h4>Step 2: Fill in the required fields of the maintenance item</h4>
		<p>Select "Category", check the box whether the item is active from the "Active Item" box and fill in the "Item Name" field in Bulgarian.</p>

        <h4>Step 3: Click the "Create" button</h4>
		<p>The maintenance item will be created and will appear in the list of maintenance items. You can add more items by repeating steps 2 and 3.</p>
        
	`,

    TEAM_MANAGEMENT_CONTENT: `
        <h3>What You Will Learn</h3>
        <ul>
            <li>How to manage your team</li>
            <li>How to add members to your team</li>  
        </ul>
        <h3>How to manage your team</h3>
        <img src="/assets/images/help-center/hotel-settings-users-management-en.png" style="border: 1px solid #ccc" />
        <p>On this page you can manage your team. <br/> You can add members to your team, change the role of the members from the dropdown menus and activate/deactivate their accounts.</p>
        <hr>
        <h3>How to invite a user to your team</h3>
        <h4>Step 1: Click the "Invite User" button</h4>
        <p>A window for inviting a user will appear.</p>
        <img src="/assets/images/help-center/hotel-settings-users-inviting-en.png" style="border: 1px solid #ccc" />
        <h4>Step 2: Fill in the fields</h4>
        <p>Fill in the "Email" field and select the role of the user.</p>
        <h4>Step 3: Click the "Invite" button</h4>
        <p>The user will be invited and will appear in the list of team members. You can invite more members by repeating steps 1, 2 and 3.</p>
    `,

    PROFILE_SETUP_GUIDE_CONTENT: `
        <h3>What You Will Learn</h3>
        <ul>
            <li>How to setup your profile</li>
            <li>How to change your password</li>
        </ul>
        <h3>How to setup your profile</h3>
        <img src="/assets/images/help-center/account-settings-en.png" style="border: 1px solid #ccc" />
        <p>On this page you can change your Name, Surname, Email and Phone. After changing any of the fields, click the "Save" button.</p>
        <hr>
        <h3>How to change your password</h3>
        <img src="/assets/images/help-center/account-settings-password-reset-en.png" style="border: 1px solid #ccc" />
        <p>Click the "Change Password" button to change your password.</p>
        <h4>Step 1: Fill in the fields</h4>
        <p>Fill in the "Old Password" and "New Password" fields.</p>
        <h4>Step 2: Click the "Save" button</h4>
        <p>The password will be changed and the system will log you in again with the new password.</p>
    `,

    ASSIGNMENTS_MANAGEMENT_CONTENT: `
        <h3>What You Will Learn</h3>
        <ul>
            <li>How to assign tasks to your team</li>
            <li>How to reassign tasks from one member of the team to another</li>
            <li>How to cancel tasks</li>
        </ul>
        <img src="/assets/images/help-center/roomie-ai-en.png" style="border: 1px solid #ccc" />
        <hr>
        <h3>How to assign tasks to your team</h3>
        <h4>Step 1:</h4>
        <ul>
            <li>Mark a room or several rooms by clicking on them</li>
            <li>Mark a whole floor from the button (Select whole floor)</li>
        </ul>
        <p>After marking, a section with an active button "Assign to Cleaner" will appear above all floors. Click on it.</p>
        <h4>Step 2: Click the "Assign to Cleaner" button</h4>
        <img src="/assets/images/help-center/roomie-ai-assignment-section-en.png" style="border: 1px solid #ccc" />
        <p>A window for assigning a task to a cleaner will appear.</p>
        <h4>Step 3: Select a cleaner and priority from the dropdown menus</h4>
        <img src="/assets/images/help-center/roomie-ai-assignment-en.png" style="border: 1px solid #ccc" />
        <h4>Step 4: Click the "Assign" button</h4>
        <p>The task will be assigned and will appear in the list of cleaning for the specific cleaner. You can continue assigning more tasks to other cleaners by repeating steps 1, 2, 3 and 4.</p>
        <hr>
    `,

	OVERVIEW_CONTENT: `
		<h4>Here you can see how many rooms are assigned, unassigned, in progress of cleaning from your team overall for the day, as well as the total duration of cleaning for each cleaner.</h4>
		<img src="/assets/images/help-center/roomie-ai-performance-analysis-en.png" style="border: 1px solid #ccc" />
	`,

	DAILY_ASSIGNMENTS_LIST_CONTENT: `
		<h4>Here you can see all tasks for each cleaner individually and their progress.</h4>
		<img src="/assets/images/help-center/roomie-ai-daily-assignments-list-en.png" style="border: 1px solid #ccc" />
	`,

	ROOMIE_AI_INTELLIGENT_ASSISTANT_CONTENT: `
		<h4>Roomie AI is an intelligent assistant that helps you manage your team more efficiently.</h4>
		<img src="/assets/images/help-center/roomie-ai-intelligent-assistant-en.png" style="border: 1px solid #ccc" />
		<p>To be effective in automatically assigning rooms to cleaners, RoomieAI requires the presence of preliminary data that it analyzes and uses.</p>
		<p>RoomieAI is a self-improving Artificial Intelligence, which is improved through daily tasks and analyzes the individual performance of each cleaner. This allows it to allocate tasks in the most optimal way.</p>
		<p>The assistant is activated automatically after collecting and processing enough information from previous days, necessary for effective analysis and decision-making.</p>
		<p>After RoomieAI is activated and has collected enough data, it takes full control of the daily task distribution to maximize efficiency.</p>
		<p>The system takes into account many factors, including the time required for each cleaner to clean different types of rooms, the total time for completing daily tasks, as well as ratings and feedback from the main cleaners regarding the quality of cleaning.</p>
		<p>Based on this analysis, RoomieAI distributes tasks individually, optimizing the workload and prioritizing high-quality service. This ensures not only higher productivity but also better customer experience.</p>
	`,

	CLEANING_OPERATIONS_CONTENT: `
		<h3>What You Will Learn</h3>
        <ul>
            <li>How to use the "Cleaning" page</li>
            <li>How to submit a technical request</li>
        </ul>
		<h3>How to use the "Cleaning" page (Main Cleaner and Administrator)</h3>
		<h4>When a user with the role of Main Cleaner or Administrator opens the "Cleaning" page, all rooms are visualized with their status and information about who is assigned to clean them, as well as the possibility of assigning/cancelling express cleaning with one click.</h4>
		<img src="/assets/images/help-center/cleaning-page-en.png" style="border: 1px solid #ccc;" />
	`,

	CLEANING_PAGE_CLEANER_CONTENT: `
		<h3>What You Will Learn</h3>
        <ul>
            <li>How to start and finish cleaning a room</li>
        </ul>
		<h3>How to start and finish cleaning a room</h3>
		<h4>On the "Cleaning" page you will see all the rooms that are assigned to you and their priority.</h4>
		<img src="/assets/images/help-center/cleaner-page-mobile-bg.png" style="border: 1px solid #ccc;" />
		<h4>Step 1: Click the "Start Cleaning" button</h4>
		<p>A window will appear with the number of rooms currently being cleaned and all tasks that need to be completed.</p>
		<img src="/assets/images/help-center/cleaner-page-currently-cleaning-en.png" style="border: 1px solid #ccc;" />
		<h4>Step 2: Mark the completed tasks with the box that is located on the left of each task</h4>
		<h4>Step 3: Click the "Finish Cleaning" button</h4>
		<p>The room will be marked as cleaned and will appear in the "Cleaned Rooms" section on the "Cleaning" page. You can continue cleaning more rooms by repeating steps 1, 2 and 3.</p>
	`,

	CLEANER_SUBMIT_PROBLEM_CONTENT: `
		<h3>What You Will Learn</h3>
        <ul>
            <li>How to submit a technical request</li>
        </ul>
		<h4>On the "Cleaning" page you will see all the rooms that are assigned to you and in each of them there is a button with an icon of tools</h4>
		<img src="/assets/images/help-center/cleaner-page-mobile-en.png" style="border: 1px solid #ccc;" />
		<h4>Step 1: Click the button with the icon of tools</h4>
		<p>A window will appear where you can select what element the problem relates to, the priority of the request and describe the problem with more information.</p>
		<img src="/assets/images/help-center/cleaner-page-tech-request-dialog-en.png" style="border: 1px solid #ccc;" />
		<h4>Step 2: After filling in the fields, click the "Create Request" button</h4>
		<p>The request will be created and the personnel responsible for technical support will be notified immediately.</p>
	`,
	
	// Related Links
	CREATING_YOUR_FIRST_ACCOUNT: 'Creating Your First Account',
	CREATING_YOUR_FIRST_ACCOUNT_DESC: 'Step by step guide to creating an account',
	DASHBOARD_NAVIGATION: 'Dashboard Navigation',
	DASHBOARD_NAVIGATION_DESC: 'Learn how to navigate effectively in the dashboard',
	PROFILE_SETUP_GUIDE: 'Profile Setup Guide',
	PROFILE_SETUP_GUIDE_DESC: 'Full guide to setting up your profile',
	ASSIGNMENTS_MANAGEMENT: 'Assignments Management',
	ASSIGNMENTS_MANAGEMENT_SUBTITLE: 'Learn how to manage your team\'s tasks',
	CONTACT_SUPPORT: 'Contact Support',
	CONTACT_SUPPORT_DESC: 'Get help from our team for support',
	
	// Common UI
	BACK_TO_GUIDES_AND_RESOURCES: 'Back to Guides',
    BACK_TO_HELP_CENTER: 'Back to Help Center',
	RELATED_ARTICLES: 'Related Articles',
	WAS_THIS_PAGE_HELPFUL: 'Was this page helpful?',
	LAST_UPDATED: 'Last updated on:',
	RECENTLY_UPDATED: 'Recently updated',
	BY: 'By',
	MIN_READ: 'min read',
	FEATURED: 'Featured',
	NEXT: 'Next',
	REMOVING_MEDIA: 'Removing media from project',
    PUBLISHED: 'Published on:',
};

export default locale;
